import React, { useState } from 'react';
import NavBarTop from '../Reusable_Components/NavBarTop';
import LeftNavBar from '../Reusable_Components/LeftNavBar';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TableComponent from '../Reusable_Components/TableComponent';
import Pagination from '../Reusable_Components/Pagination';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useNavigate } from "react-router-dom";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);



export default function OrganizationPayments() {
    const navigate = useNavigate()

    const [billingMonthFilter, setBillingMonthFilter] = useState(dayjs().month() + 1);
    const [billingYearFilter, setBillingYearFilter] = useState(dayjs().year());
    const [billingPeriodFilter, setBillingPeriodFilter] = useState(dayjs(`${billingYearFilter}-${billingMonthFilter}`));

    const [paymentStatus, setPaymentStatus] = useState("all")
    const [tableData, setTableData] = useState([{
        invoice_no: "#17001",
        billing_period: "May 2025",
        billing_amount: "3,500.00",
        status: "Approved",
        updated_by: "Bharat",
        updated_on: "100 days ago",
    },
    {
        invoice_no: "#17004",
        billing_period: "January 2025",
        billing_amount: "3,500.00",
        status: "Rejected",
        updated_by: "Dinesh",
        updated_on: "50 days ago",
    }, {
        invoice_no: "#17004",
        billing_period: "January 2025",
        billing_amount: "3,500.00",
        status: "Pending",
        updated_by: "Dinesh",
        updated_on: "150 days ago",
    }, {
        invoice_no: "#17004",
        billing_period: "January 2025",
        billing_amount: "3,500.00",
        status: "Approved",
    },
    {
        invoice_no: "#17004",
        billing_period: "December 2024",
        billing_amount: "3,500.00",
        status: "Rejected",
    },
    {
        invoice_no: "#17005",
        billing_period: "August 2025",
        billing_amount: "3,500.00",
        status: "Approved",
    }, {
        invoice_no: "#17001",
        billing_period: "April 2025",
        billing_amount: "3,500.00",
        status: "Approved",
    }, {
        invoice_no: "#17001",
        billing_period: "April 2025",
        billing_amount: "3,500.00",
        status: "Rejected",
    },])
    const [filteredData, setFilteredData] = useState(tableData)
    const handleApply = () => {
        let filtered = tableData.filter((item) => {
            let billingDate = dayjs(item.billing_period, "MMMM YYYY");
            let isSameOrAfterBillingDate = billingDate.isSameOrAfter(billingPeriodFilter, 'month');
            let isSameOrBeforeBillingDate = billingDate.isSameOrBefore(billingPeriodFilter, 'month');
            return (paymentStatus === "all" || item.status.toLowerCase() === paymentStatus.toLowerCase()) && isSameOrAfterBillingDate && isSameOrBeforeBillingDate
        });
        setFilteredData(filtered)
    }

    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            <div className='meter_reports_container d-flex flex-column' >

                <div className='d-flex justify-content-between align-items-start flex-wrap' style={{ flex: "0 1 auto" }}>
                    <div className='d-flex flex-column' style={{ lineHeight: '0' }}>
                        <h3 className="invoice-heading mb-0">Plan & Billing</h3>
                    </div>
                    {/* <div className='d-flex  align-items-center gap-3 '>
                        <button className='invoice_btn organization-payments-button' >
                            <span className='generate_invoice' onClick={() => {
                                navigate("/organizationPricing")
                            }}>Change Plan</span>
                        </button>
                        <button className='invoice_btn'>
                            <span className='generate_invoice'>Pay Now</span>
                        </button>
                    </div> */}
                    <div className='d-flex align-items-center gap-3 org-payments-actions'>
                        <button className="invoice_btn org-pricing-button" style={{ marginTop: '4px', color: 'white', height: '10px !important' }}
                            onClick={() => {
                                navigate("/organizationPricing")
                            }}
                        >Change Plan</button>
                        <button className="invoice_btn org-pricing-button" style={{ marginTop: '4px', color: 'white', height: '10px !important' }}

                        >Pay Now</button>

                    </div>

                </div>
                <div className="org-payments-card-container" style={{ flex: "0 1 auto" }}>
                    <div className="org-payments-plan-card">
                        <p className="org-payments-card-title">Current Plan</p>
                        <h3>Community</h3>
                        <p>3,500.00 INR/month</p>
                    </div>

                    <div className="org-payments-card">
                        <p className="org-payments-card-title">Next Payment</p>
                        <h3>3,500.00 INR</h3>
                        <p>Due on June 01, 2025</p>
                    </div>
                </div>


                <div className='fm-invoice-con-filters mt-4' style={{ zIndex: 100, flex: "0 1 auto" }}>
                    <div style={{ width: '120px' }} className="fin_man_billing_period">
                        <p className='organization-payment-para' style={{ marginBottom: '5px' }}>Payment Status:&nbsp;</p>
                        <select
                            // value={paymentStatusFilter}
                            // onChange={(e) => {
                            //     setPaymentStatusFilter(e.target.value);
                            // }}
                            value={paymentStatus}
                            onChange={(e) => {
                                setPaymentStatus(e.target.value);
                            }}
                            className="invoice-select-date"
                            style={{ width: "100%", height: "2.5rem" }}
                        >
                            <option value="all">All</option>
                            <option value="approved">Approved</option>
                            <option value="pending">Pending</option>
                            <option value="rejected">Rejected</option>

                            { }
                        </select>
                    </div>
                    <div className="fin_man_billing_period">
                        <p style={{ marginBottom: '5px' }}>Billing Period:&nbsp;</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                // label=""
                                value={dayjs(`${billingYearFilter}-${billingMonthFilter}`)}
                                views={['month', 'year']}
                                // minDate={dayjs('2022-01-01')} // Set minimum selectable date
                                // maxDate={dayjs('2025-01-08')} // Set minimum selectable date
                                onChange={(newValue) => {
                                    setBillingMonthFilter(dayjs(newValue).month() + 1);
                                    setBillingYearFilter(dayjs(newValue).year());
                                    setBillingPeriodFilter(newValue)
                                }
                                }

                                sx={{
                                    '.MuiInputBase-root': {
                                        height: '40px', // Adjust height
                                        width: "180px",
                                        backgroundColor: 'white', // Set background to white
                                        borderRadius: '6px', // Optional: Rounded corners
                                        fontSize: '14px', // Optional: Adjust text size
                                    },
                                }}
                                // slotProps={{
                                //     textField: {
                                //         InputProps: {
                                //             readOnly: true, // Prevent typing in the input field
                                //         },
                                //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                //     },
                                // }}
                            />
                        </LocalizationProvider>

                    </div>
                    <div className='d-flex align-items-center gap-3'>
                        <button className="invoice_btn" style={{ marginTop: '4px', color: 'white', height: '20px !important' }}
                            // onClick={() => {
                            //     applyFilterClicked()
                            // }}
                            onClick={() => {
                                handleApply()
                            }
                            }
                        >Apply</button>
                        <button className="invoice_btn" style={{ marginTop: '4px', color: 'white', height: '20px !important' }}
                            // onClick={() => {
                            //     clearFilterClicked()
                            // }}
                            onClick={() => {
                                setPaymentStatus("all")
                                setFilteredData(tableData)
                                setBillingMonthFilter(null);
                                setBillingYearFilter(null);
                                setBillingPeriodFilter(null);
                            }
                            }
                        >Clear</button>

                    </div>
                </div>


                <div className='meter_reports_table_container mt-3' style={{ flex: "1 1 auto", overflow: "auto" }}>
                    <TableComponent
                        headers={[{
                            name: "Invoice Number",
                            type: "text",
                            key: "invoice_no",
                            sort: true
                        }, {
                            name: "Billing Period",
                            type: "text",
                            key: "billing_period",
                            // sort: true
                        }, {
                            name: "Billing Amount (INR)",
                            type: "number",
                            key: "billing_amount",
                            sort: true
                        }, {
                            name: "Status",
                            type: "text",
                            key: "status",
                            // sort: true
                        }, {
                            name: "Updated By",
                            type: "text",
                            key: "updated_by",
                            sort: true
                        }, {
                            name: "Updated On",
                            type: "text",
                            key: "updated_on",
                            sort: true
                        },
                        {
                            name: "Action",
                            type: "button",
                            buttons: [{
                                name: "View",
                                icon: "./images/icons/Download.svg",
                                disable: (data) => false,
                                action: (data) => {
                                    // setSelectedTemplate(data)
                                    // setPage(3)
                                }
                            }]
                        }]}
                        data={filteredData}
                    />

                </div>
                <div style={{ flex: "0 1 auto" }}>
                    <Pagination
                        totalRecords={0}
                        recordsPerPage={10}
                        currentPaginationPage={1}
                    />
                </div>


            </div>
        </>
    );
}